module.exports = __webpack_public_path__ + "static/media/mic.df08bb94.svg";